<!--
 * =====================================================================
 * 작 업 명  : 메인 화면
 * 파 일 명  : Index.vue
 * 변경이력 
 * 2021-01-29 / 정태화 / 최초작성
 * =====================================================================
 -->
<template>
    <header class="title mt-3 mb-4 text-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="90" height="90" fill="currentColor" class="bi bi-person-circle mt-3 text-center text-dark" viewBox="0 0 16 16">
            <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>
            <path fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"/>
    </svg>
    </header>
    <h3 class="title mt-3 mb-4 text-center">Welcome, {{ user.USER_ID }}</h3>
    <h6 class="title mt-3 mb-4 text-center">Manage your info to make Dot work better for you.</h6>
    <div class="row">
        <div class="col-sm-3"> </div>
        <div class="col-sm-6 rounded-3">
            <button class="list-group-item list-group-item-action">
                <div class="row">
                    <div class="col-sm-8">
                        <h4 class="title">Personal info</h4>
                        Manage your account, basic, and password info
                    </div>
                    <div class="col-sm-4 justify-content-center d-flex align-items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="90" height="90" fill="currentColor" class="bi bi-person-lines-fill" viewBox="0 0 16 16">
                            <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2z"/>
                        </svg>
                    </div>
                </div>
            </button>
            <button class="list-group-item list-group-item-action d-flex justify-content-end">
                <div class="mt-2 mb-2">
                    <b>Manage your personal info</b>
                    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="23" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                        <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                    </svg>
                </div>
            </button>
        </div>
        <div class="col-sm-3"> </div>
    </div>
</template>
<script>
    export default 
    {
        data()
        {
            return {
                user: {
                    USER_NO: localStorage.getItem("_USER_NO_"),
                    USER_ID: localStorage.getItem("_USER_ID_"),
                }
            }
        }
    }
</script>
<style>
</style>
